export const gkx = {
  22823: true,
};
